import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store'; // Adjust the path as necessary
import ErrorBoundary from './components/ErrorBoundary';
import { startOfflineMonitor } from './offline/connection';
import { relayCustomerScreen } from './utils/customerDisplayOptions';

startOfflineMonitor(); // no-op unless the API base is the host's on-device offline engine
relayCustomerScreen(); // C20 Pro second screen: hand the restaurant's idle logo to the wrapper (no-op without it)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
